import _ from 'lodash'

import { MedicalActSuggestion } from './types'

export function sortSuggestedMedicalActs(suggestions: MedicalActSuggestion[]): MedicalActSuggestion[] {
  return _.orderBy(
    suggestions,
    [(suggestion: MedicalActSuggestion) => suggestion.searches.length, (suggestion: MedicalActSuggestion) => suggestion.prediction?.confidence ?? 0],
    ['desc', 'desc'],
  )
}
